import React from 'react'
import Img from 'gatsby-image'

const FullWidthMixedGrid = ({ data }) => {
    const { blueContentBlock, leftImage, rightImage } = data

    return (
        <section className="full-width-mixed-grid">
            <div className="image1">
                {leftImage && (
                    <img 
                        src={leftImage?.localFile?.childImageSharp?.fluid.src}
                    />
                )}
            </div>
            <div className="content-wrapper">
                {blueContentBlock.title && (
                    <h5>{blueContentBlock.title}</h5>
                )}
                {blueContentBlock.content && (
                    <div dangerouslySetInnerHTML={{ __html: blueContentBlock.content }}></div>
                )}
            </div>
            <div className="image2">
                {rightImage && (
                    <Img 
                        fluid={rightImage?.localFile?.childImageSharp?.fluid}
                    />
                )}
            </div>
        </section>
    )
}

export default FullWidthMixedGrid
